import type { RouteObject } from 'react-router'

import { SettingsPage } from '@/features/settings/SettingsPage'

export const routes: RouteObject[] = [{ path: 'settings', element: <SettingsPage /> }]
